export default __webpack_public_path__ + "static/media/chart-dine-in.d5482347.svg";